import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PrefixEvent } from "src/app/components/global/prefixes/prefix.component";
import { DefaultComponent } from "src/app/default.component";
import { TableGroup } from "../table-group";
import { TableHeader } from "../table-header";
import { TableRow } from "../table-row";
import { TableOptions } from "../table.interface";

@Component({
  selector: "app-table-view",
  imports: [],
  template: "",
})
export class TableViewComponent extends DefaultComponent implements OnInit {
  @Input({ required: true })
  public root: TableGroup;

  @Input({ required: true })
  public headers: TableHeader[];

  @Input({ required: true })
  public options: TableOptions;

  @Output()
  public rowSelection: EventEmitter<void>;
  @Output()
  public prefixEvent: EventEmitter<[PrefixEvent, TableRow]>;
  @Output()
  public sort: EventEmitter<TableHeader>;

  public constructor() {
    super();
    this.root = new TableGroup("");
    this.headers = [];
    this.options = {
      head: true,
      foot: true,
      delete: false,
      archive: false,
      add: false,
      download: false,
      search: true,
      selectable: false,
      resultslimited: false,
      resultslimitedmaxreached: false,
      filter: false,
      map: false,
      tile: false,
      pageSize: 25,
      layout: null,
    };
    this.rowSelection = new EventEmitter();
    this.prefixEvent = new EventEmitter();
    this.sort = new EventEmitter();
  }

  public ngOnInit(): void {
    this.sortColumns();
  }

  protected getAllRows(root: TableGroup | null = this.root): TableRow[] {
    if (!root) return [];
    const rows: TableRow[] = [];
    rows.push(...root.rows);

    for (const group of root.groups) {
      rows.push(...this.getAllRows(group));
    }

    return rows;
  }

  protected sortColumns(): void {}
}
